import React from 'react';
import T from 'prop-types';
import Modal from '../../../Modal';
import Button from '../../../Buttons/Button';

const AuthorizeConnectionModal = ({
  open,
  loginUrl,
  onClose,
}) => {
  const handleClose = () => onClose(false);
  return (
    <Modal
      open={open}
      size="xs"
      closeButtonIconClass="hms-btn hms-btn--light hms-btn--square hicon-close-2"
      modalClassName="authorize-connection-modal"
      onClose={handleClose}
    >
      <div className="authorize-connection-modal-body">
        <h2 className="authorize-connection-modal-title">Authorize Connection</h2>
        <p className="authorize-connection-modal-subtitle">In order to push leads to Salesforce, you must authorize the connection.</p>
      </div>
      <div className="authorize-connection-modal-btns">
        <Button size="lg" className="authorize-connection-btn" href={loginUrl}>Authorize Connection</Button>
        <Button size="lg" variant="secondary" className="cancel-btn" onClick={handleClose}>Cancel</Button>
        <Button size="lg" variant="light" className="view-integrations-btn" href="/profile/salesforce_connections">View my integrations</Button>
      </div>
    </Modal>
  );
};

AuthorizeConnectionModal.propTypes = {
  open: T.bool.isRequired,
  loginUrl: T.string.isRequired,
  onClose: T.func.isRequired,
};

export default AuthorizeConnectionModal;
